<template>
  <div class="">
    <section class="w-full section">
      <div class="max-w-6xl mx-auto">
        <div class="p-2 xl:p-4">
          <div class="banner mb-4">
            <div>
              <img class="object-contain hidden sm:block" src="@/assets/image/banner.png" alt="">
              <img class="object-contain sm:hidden" src="@/assets/image/bannerM.png" alt="">
            </div>
          </div>

          <div class="flex items-center flex-wrap mb-3 p-2">
            <p class="text-lg font-semibold mr-2 w-full md:w-auto">服務項目</p>
            <div class="text-sm cursor-pointer w-1/2 md:w-auto p-2" v-for="(item, index) in filterList" :key="index">
              <a class="px-3 py-1 border border-black rounded-lg block text-center" @click="selectedType = item.type" :class="{ 'bg-black text-white': selectedType === item.type }">{{ item.name }}</a>
            </div>
          </div>

          <div class="flex flex-wrap">
            <div class="w-1/2 md:w-1/3 lg:w-1/4 p-2 mb-2" v-for="(item, index) in filterArray" :key="index" :class="{ 'hidden': (item.type === 'EBook') }" >
              <div class="bg-white">
                <div><img class="object-contain" :src="require(`@/assets/image/${returnBG(item.type)}.png`)" alt=""></div>
                <div class="p-3">
                  <div class="flex items-center border-b pb-2 login-purple-border">
                    <div class="mr-2"><img class="object-contain" src="@/assets/image/Chart_fill.png" alt=""></div>
                    <p class="login-purple-text font-semibold" :class="{'opacity-0': item.points < 1 }">1{{ item.unit }}扣{{ item.points }}點</p>
                  </div>
                  <div class="py-3">
                    <h6 class="text-center text-lg md:text-xl font-black mb-2" >{{ item.name }}</h6>
                    <p class="text-center text-sm text-gray-quote mb-2">進行過{{ item.times }}次{{ item.unit2 }}</p>
                  </div>
                  <div class="">
                    <router-link v-if="item.type !== 'EBook'" :to="{ path: item.path }" class="p-2 block cursor-pointer">
                      <img class="object-contain mx-auto" src="@/assets/image/btn_start.png" alt="">
                    </router-link>
                    <a v-else :href="returnPath(item.view_id)" class="p-2 block cursor-pointer">
                      <img class="object-contain mx-auto" src="@/assets/image/btn_start.png" alt="">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  // import moment from 'moment'
  import { mapGetters } from 'vuex'
  import api from '@/api.js'
  export default {
    name: 'Index',
    metaInfo: {
      title: ''
    },
    components: {
    },
    data () {
      return {
        isShowMenu: false,
        selectedType: 'all',

        filterList: [
          { name: '全部', type: 'all' },
          { name: '日語', type: 'jp' },
          { name: '英語', type: 'en' },
          { name: '口說練習', type: 'chat' },
          { name: '檢定練習', type: 'gept' },
          { name: 'AI生成', type: 'ai' }
        ],

        productsList: null
      }
    },

    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints',
        'ai_sid',
        'ai_uuid',
        'user'
      ]),

      filterArray () {
        let self = this
        if (self.selectedType === 'jp') {
          let newArray = self.productsList.filter((el) => {
            return el.name === 'AI日語口說小助教' || el.name === 'AI日語演講稿生成' || el.name === 'AI日語書信生成'
          })
          return newArray
        } else if (self.selectedType === 'en') {
          let newArray = self.productsList.filter((el) => {
            return el.name === 'AI英語口說小助教' || el.name === 'GEPT 初級口說測驗' || el.name === 'GEPT 初級寫作測驗' || el.name === 'GEPT 中級口說測驗' || el.name === 'GEPT 中級寫作測驗' || el.name === 'AI英語書信生成' || el.name === 'AI英語演講稿生成'
          })
          return newArray
        } else if (self.selectedType === 'chat') {
          let newArray = self.productsList.filter((el) => {
            return el.name === 'AI英語口說小助教' || el.name === 'AI日語口說小助教'
          })
          return newArray
        } else if (self.selectedType === 'gept') {
          let newArray = self.productsList.filter((el) => {
            return el.name === 'GEPT 初級口說測驗' || el.name === 'GEPT 初級寫作測驗' || el.name === 'GEPT 中級口說測驗' || el.name === 'GEPT 中級寫作測驗'
          })
          return newArray
        } else if (self.selectedType === 'ai') {
          let newArray = self.productsList.filter((el) => {
            return el.name === 'AI英語口說小助教' || el.name === 'AI日語口說小助教' || el.name === 'AI英語書信生成' || el.name === 'AI英語演講稿生成'|| el.name === 'AI日語書信生成' || el.name === 'AI日語演講稿生成'
          })
          return newArray
        } else if (self.selectedType === 'EBook') {
          let newArray = self.productsList.filter((el) => {
            return el.name === '生活主題寫作批改' || el.name === '學測模擬寫作' || el.name === '學測歷屆寫作'
          })
          return newArray
        }

        return self.productsList
      }
    },
    mounted () {
      if (this.authorized && !this.ai_sid && !this.ai_uuid && !this.$route.query.sid && !this.$route.query.uuid) {
        this.getProducts()
      }
    },
    methods: {
      returnPath (id) {
        let token = localStorage.getItem('authorizedAIToken') || ''
        return `https://elearning.liveabc.com/books/${id}?token=${token}`
      },
      returnBG (type) {
        if (type === 'AI_CHAT' || type === 'AI_JAPANESE_SPEAKING_BEGINNER') {
          return 'bg03'
        } else if (type === 'AI_GEPT_SPEAKING_BEGINNER' || type === 'AI_GEPT_WRITING_BEGINNER' || type === 'AI_GEPT_SPEAKING_INTERMEDIATE' || type === 'AI_GEPT_WRITING_INTERMEDIATE') {
          return 'bg02'
        } else if (type === 'EBook') {
          return 'bg04'
        }
        return 'bg01'
      },

      getProducts () {
        let self = this

        let arr = [
          { name: 'AI英語口說小助教', path: '/intro/en', unit: '句', unit2: '對話' },
          { name: 'AI日語口說小助教', path: '/intro/jp', unit: '句', unit2: '對話' },
          { name: 'GEPT 初級口說測驗', path: '/GEPT/overview?level=初級&type=speaking', unit: '回', unit2: '測驗' },
          { name: 'GEPT 初級寫作測驗', path: '/GEPT/overview?level=初級&type=writing', unit: '回', unit2: '測驗' },
          { name: 'GEPT 中級口說測驗', path: '/GEPT/overview?level=中級&type=speaking', unit: '回', unit2: '測驗' },
          { name: 'GEPT 中級寫作測驗', path: '/GEPT/overview?level=中級&type=writing', unit: '回', unit2: '測驗' },
          { name: 'AI英語書信生成', path: '/generate/letter', unit: '回', unit2: '生成' },
          { name: 'AI日語書信生成', path: '/generate/jp/letter', unit: '回', unit2: '生成' },
          { name: 'AI英語演講稿生成', path: '/generate/speech', unit: '回', unit2: '生成' },
          { name: 'AI日語演講稿生成', path: '/generate/jp/speech', unit: '回', unit2: '生成' },
          { name: '生活主題寫作批改', path: '/books/25ed16aa-00a1-4e1b-8e7b-4d25dfc1986f', unit: '回', unit2: '批改' },
          { name: '學測歷屆寫作', path: '/books/85312cad-2593-474b-ab7c-f393081922ae', unit: '回', unit2: '批改' },
          { name: '學測模擬寫作', path: '/books/ca773c98-2141-482c-a1ac-2e68eb8d27d2', unit: '回', unit2: '批改' }
        ]

        let path = `/ai/products`
        self.$store.dispatch('isLoading', true)
        api.get(path)
          .then((response) => {
            self.$store.dispatch('isLoading', false)

            response.data.data.map(item1 => {
              arr.map(item2 => {
                if (item1.name === item2.name) {
                  return Object.assign(item1, item2)
                }
              })
            })

          self.productsList = response.data.data
        })
        .catch(() => {
          self.$store.dispatch('isLoading', false)
        })
      },

      logout2 () {
        this.$store.dispatch('logout')
        this.$router.replace({ name: 'login' })
      }
    }
  }
</script>
<style lang="scss" scoped>
section {
  background-color: #EAEDF2;
  min-height: 100vh;
}

.banner-text {
  left: 50%;
  top: 50%;
}
</style>
